import axios from 'axios';

export const RESPONSE_ENUM = {
  AUTH: {
    GENERAL_ERROR: -9,
    CODE_ALREADY_SENT: -1,
    MOBILE_NOT_REGISTERED: 0,
    TWO_FA_REQUIRED: 1,
    PENDING_REGISTRATION: 2,
  },
};

export const AuthService = {
  login: (body) => {
    const url = `${process.env.VUE_APP_API}/patient/account/login`;
    return axios.post(url, body);
  },
  register: (body) => {
    const url = `${process.env.VUE_APP_API}/patient/account/register`;
    return axios.post(url, body);
  },
  validate: (captchatoken) => {
    const url = `${process.env.VUE_APP_API}/patient/account/login/validate`;
    return axios.post(url, {agent: 'web3', captchatoken});
  },
};
